
  import { mapState, mapGetters } from 'vuex'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    mixins: [cms, playGames, vipSettings],
    data() {
      return {
        drawer: false,
        rateDialog: false
      }
    },
    computed: {
      message() {
        return this.$store.state.player.messages
      },
      ...mapState({
        vipTiers: state => state.activities['vip-system'].vipTiers,
        vipSystemLoading: state => state.activities['vip-system'].vipSystemLoading,
        vipTiersLoading: state => state.activities['vip-system'].vipTiersLoading,
        player: state => state.player.player,
        isLogin: state => state.settings.isLogin,
        globalFlag: state => state.settings.globalFlag,
        operationSetting: state => state.settings.operationSetting,
        isApp: state => state.app.isApp,
        missionSettings: state => state.activities['mission-reward'].missionsSettings,
        missionBadge: state => state.activities['mission-reward'].missionBadge
      }),
      globalFlagComputed() {
        return `fi fi-${this.globalFlag?.toLowerCase()}`
      },
      ...mapGetters({
        languages: 'themes/settings/language',
        headerLogo: 'cms/headerLogo',
        footerPartnerIcon: 'cms/footerPartnerIcon',
        footerArticle4: 'cms/footerArticle4',
        footerGamingInfo: 'cms/footerGamingInfo'
      }),
      infoItems() {
        return [
          {
            icon: 'mdi-account',
            text: this.tl('myProfile'),
            to: '/player/profile'
          },
          {
            icon: 'mdi-book',
            text:
              this.operationSetting?.reg_flow === 5
                ? this.tl('walletAddress')
                : this.tl('bankDetail'),
            to: '/payment-methods'
          },
          {
            icon: 'mdi-message-text-fast-outline',
            text: this.tl('message'),
            actions: this.message.total,
            to: '/player/messages'
          },
          {
            icon: 'mdi-lock',
            text: this.tl('resetPassword'),
            to: '/reset-password'
          },
          {
            icon: 'mdi-play-circle',
            text: this.tl('myBonus'),
            to: '/my-bonus'
          },
          {
            icon: 'mdi-dots-horizontal-circle-outline',
            text: this.tl('moreInfo'),
            to: '/articles'
          }
        ]
      },
      menuItems() {
        const links = [
          {
            title: 'cashier',
            icon: '/theme-2/drawer/cashier.png',
            route: '/cashier',
            status: true
          },
          {
            title: 'history',
            icon: '/theme-2/drawer/history.png',
            route: '/history/transaction',
            status: true
          },
          {
            title: 'promotion',
            icon: '/theme-2/drawer/promotion.png',
            route: '/promotion',
            status: true
          },
          {
            title: 'activities',
            icon: '/theme-2/drawer/activities.png',
            route: '/activities',
            status: this.missionStatusInfo.mission_status
          }
        ]

        return links.filter(item => item.status)
      }
    },
    mounted() {
      // Call this store action only when the user is not on the home page but on mobile device
      if (this.isMobileOnly() && !this.$cookie.get('token'))
        this.$store.dispatch('cms/footerCMS', { platform: 2 })
      // Call this store action only when the user is not on the home page
      if (this.$route.path !== '/')
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'HeaderLogo'
        })
      if (this.$cookie.get('token')) {
        if (this.player.player_id) return
        this.$store.dispatch('player/profile')
        this.$store.dispatch('settings/toggleIsLogin', true)
        this.$store.dispatch('player/totalBalance')
      }
    },
    beforeDestroy() {
      this.doCancelAxiosRequest()
    },
    methods: {
      getCurrentLocale(localeCode) {
        const currentLocaleData = this.languages.filter(el => el.code === localeCode)
        if (currentLocaleData.length > 0) {
          return currentLocaleData[0]?.flag_icon
        }
        return null
      },
      openExchangeRateDialog() {
        this.rateDialog = true
        setTimeout(() => {
          const idExchange = document.getElementById('idExchangeRate')
          idExchange.classList.remove('v-list-item--active')
        }, 1000)
      }
    }
  }
